module.exports = __webpack_public_path__ + "c01a630a0aed99d08fffdb3018830081.png";